import { Phone } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-slate-800 rounded-sm flex items-center justify-center">
              <Phone className="w-4 h-4 text-slate-400" />
            </div>
            <span className="font-heading text-xl font-bold text-slate-400">
              RoofConverse.AI
            </span>
          </div>

          {/* Copyright */}
          <p className="text-slate-500 text-sm text-center">
            © {currentYear} RoofConverse.AI. All rights reserved.
          </p>

          {/* Tagline */}
          <p className="text-slate-500 text-sm">
            Revenue Optimization for Roofing Companies
          </p>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-8 border-t border-slate-800">
          <p className="text-slate-600 text-xs text-center max-w-2xl mx-auto">
            Results may vary. The 30% improvement in booked inspections is based on client case studies and depends on factors including lead quality, market conditions, and sales team performance. Past results do not guarantee future performance.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
